import React from "react";
import { Send } from "react-feather";

const SendNowBar = ({ selectedCustomers, onSend, currency, total }) => {
  if (!selectedCustomers.length) return null;
  
  return (
    <div className="send-now-bar shadow-lg">
      <div className="d-flex justify-content-between align-items-center">

        <div className="font1">
          <b>{selectedCustomers.length}</b> Customer(s) selected <br/>           
          <h5 className="ml-3 text-success font-bold">
            <span className="text-dark">Potential Revenue:</span> {currency} {total.toLocaleString()}
          </h5>
        </div>

        <button className="btn btn-primary font1" onClick={onSend}>
          <Send size={14} /> Send Now
        </button>
      </div>
    </div>
  );
};

export default SendNowBar;